import { render, staticRenderFns } from "./postItem.vue?vue&type=template&id=70202af0&scoped=true&"
import script from "./postItem.vue?vue&type=script&lang=js&"
export * from "./postItem.vue?vue&type=script&lang=js&"
import style0 from "./postItem.vue?vue&type=style&index=0&id=70202af0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70202af0",
  null
  
)

export default component.exports